<template>
  <div class="Rebate-container">
    <el-select
      v-model="value"
      ref="select"
      placeholder="请选择售后赔款账户，可输入关键字搜索"
      filterable
      clearable
      prefix-icon="el-icon-search"
      :filter-method="searchOrder"
      :style="tcfstyle"
      @clear="clearSelect">
      <el-option :value="value" :label="changeLabel" style="height: auto;padding: 0;">
        <el-table
          :data="tableData"
          :show-header="false"
          :row-style="{cursor: 'pointer'}"
          @row-click="openDetails"
          style="width: 100%">
          <el-table-column
            label="赔款名称"
            min-width="160"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag :disable-transitions="true" size="mini" v-if="scope.row.ismeet===1">适用</el-tag>
              <el-tag :disable-transitions="true" size="mini" v-if="scope.row.ismeet===0" type="danger">不适用</el-tag>
              <span style="color:#000;margin-left: 6px;">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="账户余额"
            width="100"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{scope.row.balance}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="抵款方式"
            width="120"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.credit===0">最高冲抵{{scope.row.maximpact}}%</span>
              <span v-if="scope.row.credit===9">任意冲抵</span>
            </template>
          </el-table-column>
        </el-table>
      </el-option>
      <el-pagination
        v-if="total>0"
        style="padding:10px"
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-select>
  </div>
</template>

<script>
import { getDealerAccountAfterListByOrderid } from '@/api/erp'

export default {
  name: 'Rebate',
  props: {
    orderid: {
      type: String
    },
    tcfstyle: {
      type: String,
      default: 'width: 100%'
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      filterText: '',
      value: '',
      changeLabel: ''
    }
  },
  created() {
    this.getData()
    // if (this.oldorderid !== null && this.oldorderid !== '' && this.oldorderid !== undefined) {
    //   getOrderById({ orderid: this.oldorderid }).then(response => {
    //     this.value = response.data.orderid
    //     this.changeLabel = response.data.ordernum + ' / ' + response.data.produnum + ' / ' + response.data.address
    //     this.$emit('input', this.value)
    //   }).catch(() => {})
    // }
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        orderid: this.orderid,
        content: this.filterText,
        page: this.currentPage,
        limit: this.pageSize
      }
      getDealerAccountAfterListByOrderid(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    clearSelect() {
      this.filterText = ''
      this.value = null
      this.changeLabel = ''
      this.$emit('input', this.value)
      this.$emit('setAfter', null)
    },
    searchOrder(val) {
      this.filterText = val
      this.getData()
    },
    openDetails(data) {
      this.value = data.daaid
      this.changeLabel = data.name
      this.$emit('input', this.value)
      this.$emit('setAfter', data)
      this.$refs.select.blur()
    }
  }
}
</script>
<style lang="scss" scoped>
.OrderSelect-container{
  .el-table::before{
    height: 0!important;
  }
  .el-pagination{
    margin-top: 20px;
  }
}
</style>
